import React, { useState } from 'react';
import { Modal, Input, Row, Form, Select } from 'antd';
import { editMultiModel } from '../../../lib/api/algorithm-api';
import { Model } from '../../../types';
import { FormItemLabel, ModalTitle } from '../../../components/text/Titles';
import { CONFIG } from '../../../config/Config';

const { Option } = Select;

type Props = { visible: boolean; onClose: () => any; onCancel: () => any; model: Model };

export const RenameMultiModel = (props: Props) => {
  const { visible, onClose, onCancel, model } = props;

  const [name, setName] = useState<null | string>(model.name);
  const [flowName, setFlowName] = useState<null | string>(model.info.flowName || '');
  const [flowMode, setFlowMode] = useState<null | string>(model.info.flowMode || '');

  const onRename = async () => {
    if (!name) return;

    let newName = name !== model.name ? name : null;
    const request = await editMultiModel(model.id, flowMode, flowName, model.info, newName);
    console.log(request);
    onClose();
  };

  return (
    <Modal
      maskClosable={false}
      width={768}
      visible={visible}
      title={<ModalTitle>Edit model: {model.name}</ModalTitle>}
      onOk={onRename}
      onCancel={onCancel}>
      <>
        <Row style={{ marginTop: '16px' }}>
          <Form layout={'vertical'}>
            <Form.Item label="Name">
              <Input value={name || undefined} onChange={event => setName(event.target.value)} />
            </Form.Item>
            <FormItemLabel>Flow name</FormItemLabel>
            {CONFIG.multiflow.definitions && (
              <Select
                style={{ minWidth: 300, margin: '0px 0px 20px 0px' }}
                value={flowName || undefined}
                onChange={(value: string) => setFlowName(value)}>
                {CONFIG.multiflow.definitions.map(def => (
                  <Option key={def.name} value={def.name}>
                    {def.name}
                  </Option>
                ))}
              </Select>
            )}
            <FormItemLabel>Mode</FormItemLabel>
            <Select value={flowMode || ''} onChange={setFlowMode} style={{ width: '100%', margin: '0px 0px 20px 0px' }}>
              <Option key="layout" value="layout">
                Layout
              </Option>
              <Option key="vat" value="VAT">
                VAT
              </Option>
              <Option key="supplierName" value="supplierName">
                Supplier Name
              </Option>
              <Option key="always" value="always">
                Run Always
              </Option>
            </Select>
          </Form>
        </Row>
      </>
    </Modal>
  );
};
